<template>
  <div type="tabs-basic-view" title="tab-basic" :class="{'coupon-list-tab':true,'couponList':isp}">
    <div slot="content" class="content">
      
      <van-tabs v-model="active" line-width="20px" color="#333333">
          <van-tab
              v-for="(item, index) in tabs"
              :key="index"
              :title="item.label"
              :name="item.name"
              class="van-tab">
              <template #title><span class="vant-title">{{ item.label }}</span></template>
              <CouponMain :list=" $attrs[item.name] " :tabName="item.name" v-bind="$attrs" v-on="$listeners"></CouponMain>
          </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import {plateForm } from '@/utils';
import { Tab, Tabs } from 'vant';
import CouponMain from './coupon-main'
export default {
    components: {
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        CouponMain
    },
    computed: {
        isp() {
            if (plateForm().os === 'ios') {
                return true;
            }
            return false;
        }
    },
    data() {
        return {
            active: 'canUse',
            selectedLabel: this.$i18n.t('message.shop.coupon.canUse'),
            iconNothing:
        'https://fr-static.shopshops.top/20200328/Lark20191120155832.5b4a4cd093dc803a.gif',
            iconGoodView:
        'https://fr-static.shopshops.top/20200328/Lark20191120171124.332f19215669fb4d.png',
            tabs: [
                {
                    label: this.$i18n.t('message.shop.coupon.canUse'),
                    // list: this.$attrs.canUse,
                    name: 'canUse'
                }, {
                    label: this.$i18n.t('message.shop.coupon.cannotUse'),
                    // list: this.$attrs.cannotUse,
                    name: 'cannotUse'
                },
            ],
        };
    },
    watch: {
        selectedLabel(newV) {
            console.log(newV);
        },
    }
};
</script>
<style lang="less">
.coupon-list-tab {
  height: 100%;
  width: 100%;
  background-color: #f4f7f7;
  .van-tabs{
    height: 100%;
  }
  .van-tabs__wrap{
      height: 44px;
  }
  .content {
    height: 100%;
  }
  .coupon-list-component::-webkit-scrollbar {
    display: none;
  }
  .van-tab{
    display: flex;
    height: 100%;
    position: static !important;
    flex: 1;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 0 2px;
    color: #646566;
    font-size: 7px;
    line-height: 14px;
    cursor: pointer;
    .vant-title{
      font-size: 14px;
    }
  }
  .tab-box {
    width: 100%;
    height: 60px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
    color: #161a1a;
    border-bottom: 2px solid #8dc6c7;
    background: #fff;
  }
}
</style>
